module.exports = __webpack_public_path__ + "img/222A0775.07dc03b3.jpg";